import {buildObjectWhenExists, throwIfUndefined} from '@coolcolduk/util';
import axios, {Axios} from 'axios';
import {AxiosCacheInstance, setupCache} from 'axios-cache-interceptor';
import {getFirebaseFunction} from '../../setup/firebase';

export interface GetAxiosOption {
  token?: string;
  contentType?: string;
  params?: any;
}

const axGlobal: Record<string, AxiosCacheInstance | Axios> = {};

export default function getAxios(base: string = '', options: GetAxiosOption = {}): AxiosCacheInstance | Axios {
  const key = JSON.stringify({base, options});
  if (!axGlobal[key]) {
    const {params, token, contentType} = options;
    axGlobal[key] = setupCache(
      axios.create({
        baseURL: getFirebaseFunction(base),
        params,
        withCredentials: true,
        headers: {
          'Content-Type': contentType || 'application/json',
          ...buildObjectWhenExists('Authorization', token ? `Bearer ${token}` : undefined),
        },
      }),
    );
  }
  return throwIfUndefined(axGlobal[key]);
}
